import { DATA_SOURCE_PREFIX } from 'src/common/constants/uris';

export const getDataSourceNameFromUri = (uri: string) =>
  uri.split(DATA_SOURCE_PREFIX)[1];
